export default function Error() {
    return function (err_code, err_desc) {
        this.code = err_code;
        this.description = err_desc;
    };
}
